import { getLookupFromLocalStorage } from '../helpers/utils';
import { yesOrNoEnum } from '@/helpers/enum';
import local from '@/local/ar';
export default {
  applyTypes: (getLookupFromLocalStorage('applyTypes') || []).filter(a => a.isActive == false),
  countries: getLookupFromLocalStorage('countries'),
  subCities: getLookupFromLocalStorage('subCities', true),
  districts: getLookupFromLocalStorage('districts', true),
  gender: [
    {
      name: local.gender.male,
      id: 1,
    },
    {
      name: local.gender.female,
      id: 2,
    },
  ],
  status: [
    {
      name: local.status.active,
      id: 1,
    },
    {
      name: local.status.inActive,
      id: 2,
    },
  ],
  yesOrNo: [
    {
      id: 1,
      name: local.yesNoOption.yes,
    },
    {
      id: 0,
      name: local.yesNoOption.no,
    },
  ],
  yesNoOption: [
    {
      name: local.yesNoOption.yes,
      id: yesOrNoEnum.yes,
    },
    {
      name: local.yesNoOption.no,
      id: yesOrNoEnum.no,
    },
  ],
  months: [
    {
      id: 1,
      name: 'يناير',
    },
    {
      id: 2,
      name: 'فبراير',
    },
    {
      id: 3,
      name: 'مارس',
    },
    {
      id: 4,
      name: 'إبريل',
    },
    {
      id: 5,
      name: 'مايو',
    },
    {
      id: 6,
      name: 'يونيو',
    },
    {
      id: 7,
      name: 'يوليو',
    },
    {
      id: 8,
      name: 'أغسطس',
    },
    {
      id: 9,
      name: 'سبتمبر',
    },
    {
      id: 10,
      name: 'أكتوبر',
    },
    {
      id: 11,
      name: 'نوفمبر',
    },
    {
      id: 12,
      name: 'ديسمبر',
    },
  ],
};
